/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Camera_ExpandInputs */

const vi_fleet_camera_expand = /** @type {(inputs: Fleet_Camera_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phóng lớn`)
};

/**

* @param {Fleet_Camera_ExpandInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_expand = /** @type {((inputs?: Fleet_Camera_ExpandInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_ExpandInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_expand(inputs)
});